import axios from 'axios'
import {CONFIG} from '@/config/config'

function authToken () {
  axios.post(`${CONFIG.URL_AUTH_API}/v1/auth/`,
    {apikey: CONFIG.API_KEY}, {sha1: false}
  ).then(response => {
    // empty
  }).catch(error => {
    if (error.response.status === 401) {
      localStorage.token = error.response.data.access_token
      localStorage.token = error.response.data.access_token
    } else {
      // TODO: Handle unexpected AuthAPI response here.
      console.error(error)
    }
  })
}

function verificaTokenUsuario () {
  try {
    if (localStorage.token !== '') {
      var splitToken = localStorage.token.split('.')
      if (splitToken.length > 1) {
        var tokenData = JSON.parse(window.atob(splitToken[1]))
        if ('user' in tokenData['data']) {
          // Token de usuário presente no localStorage
          return true
        }
      }
    }
  } catch (e) {
    console.log(`Token inválido/inexistente no localStorage: " ${e.toString()}`)
  }
  return false
}

function showApps () {
  var element = document.getElementById('wrapApps')
  element.classList.add('show')
}

function hideApps () {
  var element = document.getElementById('wrapApps')
  element.classList.remove('show')
}

function validaCPF (cpfInput) {
  var Soma
  var Resto
  var i
  Soma = 0
  cpfInput = cpfInput.replace(/\D/g, '')

  if (cpfInput === '000.000.000-00' || cpfInput === '00000000000') {
    return false
  }

  for (i = 1; i <= 9; i++) {
    Soma = Soma + parseInt(cpfInput.substring(i - 1, i)) * (11 - i)
  }

  Resto = (Soma * 10) % 11

  if ((Resto === 10) || (Resto === 11)) {
    Resto = 0
  }
  if (Resto !== parseInt(cpfInput.substring(9, 10))) {
    return false
  }

  Soma = 0

  for (i = 1; i <= 10; i++) {
    Soma = Soma + parseInt(cpfInput.substring(i - 1, i)) * (12 - i)
  }

  Resto = (Soma * 10) % 11

  if ((Resto === 10) || (Resto === 11)) {
    Resto = 0
  }
  if (Resto !== parseInt(cpfInput.substring(10, 11))) {
    return false
  } else {
    return true
  }
}

export {showApps, hideApps, authToken, verificaTokenUsuario, validaCPF}



// WEBPACK FOOTER //
// ./src/assets/js/script.js